<ion-item lines="full">
  <ion-title class="ion-no-padding ion-padding-start ion-padding-vertical"
    ><b>{{ 'owner_revoke' | translate }}</b></ion-title
  >
  <ion-buttons slot="end">
    <ion-button (click)="dismiss('cancel')"
      ><ion-icon name="close-outline"></ion-icon
    ></ion-button>
  </ion-buttons>
</ion-item>
<div class="ion-margin-bottom">
  <ion-grid class="ion-margin-top">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-icon
          color="medium"
          class="icon-x3"
          name="information-circle"
        ></ion-icon>
      </ion-col>
    </ion-row>
    <ion-col class="ion-text-center">
      <ion-label class="ion-no-padding ion-padding-horizontal panel-label-text">
        {{ 'owner_revokeCheck' | translate }}
      </ion-label>
    </ion-col>
  </ion-grid>
</div>
<ion-footer>
  <div class="ion-text-center ion-padding">
    <ion-button
      color="primary"
      class="ion-align-self-center"
      (click)="dismiss('cancel')"
    >
      <small>{{ 'general_cancel' | translate }}</small></ion-button
    >
    <ion-button
      type="submit"
      (click)="dismiss('confirmed')"
      color="primary"
      class="ion-align-self-center"
    >
      <small>{{ 'general_ok' | translate }}</small></ion-button
    >
  </div>
</ion-footer>
